import { useState, useEffect } from "react";

const NewProfileDetails = ({ userid }) => {
  const [activeTab, setActiveTab] = useState("Profile");
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (activeTab === "About") {
      fetchCandidateDetails();
    }
  }, [activeTab]);

  const fetchCandidateDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/candidate/${userid}`);
      if (!response.ok) throw new Error("Failed to fetch candidate details");
      const data = await response.json();
      setCandidateDetails(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-lg p-6">
        {/* Profile Header */}
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center space-x-4">
            {candidateDetails?.personalDetailsId?.profilePic ? (
              <img
                src={`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${candidateDetails?.personalDetailsId?.profilePic}`}
                alt="Profile"
                className="w-24 h-24 rounded-full object-cover"
              />
            ) : (
              <img
                src="https://via.placeholder.com/100"
                alt="Profile"
                className="w-24 h-24 rounded-full object-cover"
              />
            )}
            <div>
              <h1 className="text-2xl font-bold">
                {candidateDetails?.personalDetailsId?.name || "Loading..."}
              </h1>
              <p className="text-gray-500">Graduate Engineer Trainee</p>
              <p className="text-blue-500">
                {candidateDetails?.personalDetailsId?.email || "N/A"}
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="mt-6 border-b">
          <nav className="flex space-x-6">
            {["About", "Profile", "Job", "Documents", "Assets"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-2 text-lg font-medium ${
                  activeTab === tab
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : "text-gray-500"
                }`}
              >
                {tab}
              </button>
            ))}
          </nav>
        </div>

        {/* Dynamic Section */}
        <div className="mt-6">
          {activeTab === "About" && (
            <About
              candidateDetails={candidateDetails}
              loading={loading}
              error={error}
            />
          )}
          {activeTab === "Profile" && <Profile />}
          {activeTab === "Job" && <Job />}
          {activeTab === "Documents" && <Documents />}
          {activeTab === "Assets" && <Assets />}
        </div>
      </div>
    </div>
  );
};

// Components for each section
const About = ({ candidateDetails, loading, error }) => {
  if (loading) return <p>Loading candidate details...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <h2 className="text-xl font-bold mb-2">About</h2>
      {candidateDetails ? (
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <p className="text-gray-500">First Name</p>
            <p>{candidateDetails?.personalDetailsId?.name || "N/A"}</p>
          </div>
          <div>
            <p className="text-gray-500">Last Name</p>
            <p>{candidateDetails?.personalDetailsId?.LastName || "N/A"}</p>
          </div>
          <div>
            <p className="text-gray-500">Email</p>
            <p>{candidateDetails?.personalDetailsId?.email || "N/A"}</p>
          </div>
          <div>
            <p className="text-gray-500">Contact</p>
            <p>{candidateDetails?.personalDetailsId?.Contact || "N/A"}</p>
          </div>
          <div>
            <p className="text-gray-500">Date of Birth</p>
            <p>
              {candidateDetails?.personalDetailsId?.dob
                ? new Date(
                    candidateDetails?.personalDetailsId?.dob
                  ).toLocaleDateString()
                : "N/A"}
            </p>
          </div>
        </div>
      ) : (
        <p>No details available</p>
      )}
    </div>
  );
};

const Profile = () => (
  <div>
    <h2 className="text-xl font-bold mb-2">Primary Details</h2>
    <div className="grid md:grid-cols-2 gap-4">
      <div>
        <p className="text-gray-500">First Name</p>
        <p>Omkar</p>
      </div>
      <div>
        <p className="text-gray-500">Last Name</p>
        <p>Jaiswal</p>
      </div>
      <div>
        <p className="text-gray-500">Date of Birth</p>
        <p>12 Aug, 2002</p>
      </div>
      <div>
        <p className="text-gray-500">Gender</p>
        <p>Male</p>
      </div>
    </div>
  </div>
);

const Job = () => (
  <div>
    <h2 className="text-xl font-bold mb-2">Job Information</h2>
    <p>Details about job...</p>
  </div>
);

const Documents = () => (
  <div>
    <h2 className="text-xl font-bold mb-2">Documents</h2>
    <p>Uploaded documents...</p>
  </div>
);

const Assets = () => (
  <div>
    <h2 className="text-xl font-bold mb-2">Assets</h2>
    <p>Company assets...</p>
  </div>
);

export default NewProfileDetails;
